export default __webpack_public_path__ + "static/media/D2.61b38391.mp3";